import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "pages/Home";
import NotFound from "pages/NotFound";
import ExtraPage from "pages/extrapage";
import PrivateRoute from "PrivateRoutes";
import MerchantHomePage from "./pages/loyalty/index";
const RedeemVouchers = React.lazy(() => import("pages/RedeemVouchers"));
const HowItWorks = React.lazy(() => import("pages/loyalty/howitworks"));
const ForgotPassword = React.lazy(() =>
  import("pages/loyalty/forgot-password")
);
const LoyaltyOTPVerification = React.lazy(() => import("pages/loyalty/verify"));
const LoyaltyDashboard = React.lazy(() => import("pages/loyalty/dashboard"));
const LoyaltyHistory = React.lazy(() => import("pages/loyalty/history"));
const LoyaltyPaymentMethods = React.lazy(() =>
  import("pages/loyalty/payment-methods")
);
const OldLoyalty = React.lazy(() => import("pages/loyalty/old_index"));
const LoyaltyProfile = React.lazy(() => import("pages/loyalty/profile"));

const ProjectRoutes = () => {
  return (
    <React.Suspense fallback={<>Loading...</>}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />

          <Route path="/:slug/login" element={<Navigate to=".." replace />} />
          <Route
            path="/:slug/register"
            element={<Navigate to=".." replace />}
          />

          <Route path="/:slug" element={<MerchantHomePage />} />
          <Route path="/:slug/how-it-works" element={<HowItWorks />} />
          <Route path="/:slug/forgot-password" element={<ForgotPassword />} />
          <Route path="/:slug/verify" element={<LoyaltyOTPVerification />} />

          {/*------------------  Protected routes -----------------*/}
          <Route element={<PrivateRoute />}>
            <Route path="/:slug/dashboard" element={<LoyaltyDashboard />} />
            <Route path="/:slug/history" element={<LoyaltyHistory />} />
            <Route path="/:slug/profile" element={<LoyaltyProfile />} />
            <Route
              path="/:slug/payment-methods"
              element={<LoyaltyPaymentMethods />}
            />
          </Route>
          {/*------------------  Protected routes -----------------*/}

          <Route path="/extrapage" element={<ExtraPage />} />
          <Route path="/loyaltypage" element={<OldLoyalty />} />
          <Route path="/redeemvouchers" element={<RedeemVouchers />} />
        </Routes>
      </Router>
    </React.Suspense>
  );
};
export default ProjectRoutes;
